// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"rZmwvWmIl7","breadcrumbs-container":"FjzcgHilT6","breadcrumbsContainer":"FjzcgHilT6"};